import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Input } from "antd";
import EditIcon from "@mui/icons-material/Edit";

const accountDetail = () => {
  return (
    <div>
      <Row>
        <Col>
          <div className="acc-details">
            <div className="title"> Account Details </div>
            <div className="user-content">
              <Row>
                <Col md={6} className="email-container">
                  <div className="email-wrap d-flex justify-content-center flex-column align-items-center h-100">
                    {/* <div className="mail-info">
                      <div className="label-account">Email</div>
                      <div className="acc-inp-cont">bhatt.digant@gmail.com</div>
                      <Input
                          type="text"
                          placeholder="bhatt.digant@gmail.com"
                          className="number"
                        />
                    </div> */}
                    <div className="contact-info ">
                      <div className="label-account">Email *</div>
                      <div className="acc-inp-cont">
                        <EditIcon  className="edit-icon" />
                        <Input
                          type="text"
                          placeholder=" bhatt.digant@gmail.com"
                          className="number"
                        />
                      </div>
                    </div>

                    {/* <div className="contact-info ">
                      <div className="label-account">Password *</div>
                      <div className="acc-inp-cont">
                        <EditIcon  className="edit-icon" />
                        <Input
                          type="text"
                          placeholder="Enter Password"
                          className="number"
                        />
                      </div>
                    </div> */}
                  </div>
                </Col>

                <Col md={6} className="email-container">
                  <div className="passwod-wrap d-flex justify-content-center flex-column align-items-center h-100  ">
                    <div className="mail-info contact-info contact-info-wrap">
                      <div className="label-account">Mobile * </div>
                      <div className="acc-inp-cont">
                        <EditIcon className="edit-icon" />
                        <Input
                          type="text"
                          placeholder="9974920002"
                          className="number"
                        />
                      </div>
                    </div>

                    {/* <div className="contact-info contact-info-wrap">
                      <div className="label-account">Confirm Password*</div>
                      <div className="acc-inp-cont">
                        <EditIcon  className="edit-icon"/>
                        <Input
                          type="text"
                          placeholder="Confirm Password"
                          className="number"
                        />
                      </div>
                    </div> */}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default accountDetail;
